export default {
  styledSection: {
    width: '100%',
    p: ['64px 64px 24px 64px', '64px 64px 24px 64px', '116px 195px 40px 195px', '116px 195px 40px 195px'],
    h2: {
      pb: 0
    }
  }
};